import {
  EventTypes,
  track,
  trackKeyGrowthEvent,
  PageSource,
} from '@mc/track-event'
import {
  ActionTypes,
  KeyTypes,
  saveUserData,
  getTrackedId,
} from '@mc/user-data'
import { PageSourceType } from 'components/SubcatCourses/events'

export const trackPrimaryBreadcrumbClick = (
  slug: string,
  primaryCategoryName: string,
) => {
  track(EventTypes.COURSE_MARKETING_CLICK, {
    category: 'category',
    location: 'breadcrumbs',
    action: primaryCategoryName,
    class: slug,
  })
}

export const trackSubcatRowArrowClicked = (
  subcategoryName: string,
  subcategoryId: number,
  primaryCategoryName: string,
  row: number,
  pageSource: PageSourceType,
) => {
  const eventNamesByPageSource = {
    [PageSource.CLASS_PAGE]: EventTypes.COURSE_MARKETING_CLICK,
    [PageSource.EPISODE_PAGE]: EventTypes.EPISODE_PAGE_CLICK,
    [PageSource.SUBCATEGORY]: EventTypes.SUBCATEGORY_PAGE_CLICK,
    [PageSource.OUTCOME]: EventTypes.OUTCOME_PAGE_CLICK,
  }

  const key = KeyTypes.SUBCATEGORY
  const subcatId = getTrackedId({ key, id: subcategoryId })
  const eventName =
    eventNamesByPageSource[pageSource] || EventTypes.COURSE_MARKETING_CLICK

  track(eventName, {
    category: 'explore-class-catalog',
    location: `sub_category_carousel:${subcategoryName}`,
    action: 'click',
    row_position: row,
    subcategory_name: subcategoryName,
    subcategory_id: subcategoryId,
    category_name: primaryCategoryName,
    stored_subcategory_id: subcatId,
  })

  if (pageSource === PageSource.CLASS_PAGE)
    saveUserData({
      key,
      id: subcatId,
      actionType: ActionTypes.BROWSING,
      eventName,
    })
}

export const trackSubcatPillClick = (
  subcategoryName: string,
  primaryCategoryName: string,
) => {
  track(EventTypes.COURSE_MARKETING_CLICK, {
    category: primaryCategoryName,
    location: 'lesson_details',
    action: `subcategory: ${subcategoryName}`,
  })
}

export const trackOutcomePillClick = (outcomeName: string) => {
  track(EventTypes.COURSE_MARKETING_CLICK, {
    location: 'lesson_details',
    action: `outcome: ${outcomeName}`,
  })
}

export const trackSubcatCarouselViewed = (
  subcategoryName: string,
  primaryCategoryName: string,
  row: number,
) => {
  trackKeyGrowthEvent(EventTypes.COURSE_MARKETING_PAGE_ROW_VIEWED, {
    category: 'explore-class-catalog',
    row_name: `sub_category_carousel:${subcategoryName}`,
    row_position: row,
    category_name: primaryCategoryName,
  })
}

export const trackSubcatBreadcrumbClick = (
  slug: string,
  primarySubcategoryName: string,
) => {
  track(EventTypes.COURSE_MARKETING_CLICK, {
    category: 'subcategory',
    location: 'breadcrumbs',
    action: primarySubcategoryName,
    class: slug,
  })
}
